import { calculateMonthlyTakeHomeCents } from '@fruitful/member-profile';
import type {
    DeepPartial,
    MoneyMapWithRulesAndAccounts,
} from '@fruitful/types';

import type { MembershipDetails } from '../../entities/entityTypes';

/**
 * Monthly take-home used across Money Mapper when Take-home pay tab data should win:
 * money map's stored `monthlyIncomeCents` when set, otherwise sum of main membership incomes.
 */
export const getMoneyMapperEffectiveMonthlyIncomeCents = ({
    moneyMap,
    membershipIncomes,
}: {
    moneyMap: DeepPartial<MoneyMapWithRulesAndAccounts>;
    membershipIncomes: MembershipDetails['membershipIncomes'] | undefined;
}): number => {
    if (moneyMap.monthlyIncomeCents != null) {
        return moneyMap.monthlyIncomeCents;
    }

    const fromSources = calculateMonthlyTakeHomeCents(membershipIncomes ?? []);
    if (fromSources > 0) {
        return fromSources;
    }

    return 0;
};

export const moneyMapperTakeHomeTabControlsIncomeDisplay = ({
    moneyMap,
    membershipIncomes,
}: {
    moneyMap: DeepPartial<MoneyMapWithRulesAndAccounts>;
    membershipIncomes: MembershipDetails['membershipIncomes'] | undefined;
}): boolean => {
    const fromSources = calculateMonthlyTakeHomeCents(membershipIncomes ?? []);
    return (moneyMap.monthlyIncomeCents ?? 0) > 0 || fromSources > 0;
};
